import { render, staticRenderFns } from "./StockInventory.vue?vue&type=template&id=ff9cca60&scoped=true"
import script from "./StockInventory.vue?vue&type=script&lang=js"
export * from "./StockInventory.vue?vue&type=script&lang=js"
import style0 from "./StockInventory.vue?vue&type=style&index=0&id=ff9cca60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff9cca60",
  null
  
)

export default component.exports